export const features = [
  {
    title: 'Unique everything',
    content:
      'We have millions of one-of-a-kind so you can find whatever you need (or really, really want).'
  },
  {
    title: 'Independent sellers',
    content:
      'Buy directly from someone who put their heart and soul into making something special.'
  },
  {
    title: 'Secure shopping',
    content: 'We use best-in-class technology to protect your transactions.'
  }
];
